// extracted by mini-css-extract-plugin
export default {"dialogDescription":"InviteLink_dialogDescription__qhbBK","dialogButtons":"InviteLink_dialogButtons__9BxQs"};